export default __webpack_public_path__ + "aa6dd5537db77ec0f2f5ffe332921795.svg";